<section class="main-section">
  <form>
    <div class="row">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black">Recipient Information</h2>
          <div class="row mt-3">
            <div class="col-md-4 mt-4">
              <div class="form-group">
                <label>Product Owner Name</label>
              </div>
            </div>
            <div class="col-md-4 mt-4">
              <div class="form-group">
                <label>Warehouse Name</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black mb-3">Stock Entry Details</h2>
          <div class="row">
            <div class="col-md-10">
              <table class="table">
                <thead>
                <tr>
                  <th>Product Name</th>
                  <th>Quantity Sent</th>
                  <th>Quantity Received</th>
                </tr>
                </thead>
                <tbody>
                <tr>

                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col">
        <div class="inner-box">
          <h2 class="text-black">Shipping Instructions</h2>
          <div class="row mt-5">
            <div class="col-lg-4 col-md-6">
              <div class="form-group">
                <label>Shipping Instructions</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12 text-right">
        <button type="reset" class="btn btn-cancel">Close</button>
      </div>
    </div>
  </form>
</section>
